// @flow
import * as types from "../constants/action-types";
import initialState from "./initial-state";
import * as R from "ramda";


export const toolsReducer = R.cond([
    [
        (state, action) => (action.type === types.IS_BUSY),
        (state) => ({
            ...state,
            isBusy: true
        })
    ],
    [
        (state, action) => (action.type === types.QUERY_FAQS_FAIL),
        (state, action) => ({
            ...state,
            isBusy: false,
            error: action.payload.error
        })
    ],
    [
        (state, action) => (action.type === types.QUERY_FAQS_SUCCESS),
        (state, action) => ({
            ...state,
            isBusy: false,
            faqs: action.payload,
            error: null
        })
    ],
    [
        (state, action) => (action.type === types.QUERY_CELEBRATIONS_FAIL),
        (state, action) => ({
            ...state,
            isBusy: false,
            error: action.payload.error
        })
    ],
    [
        (state, action) => (action.type === types.QUERY_CELEBRATIONS_SUCCESS),
        (state, action) => ({
            ...state,
            isBusy: false,
            celebrations: action.payload,
            error: null
        })
    ],
    [
        (state, action) => (action.type === types.QUERY_TOWNS_FAIL),
        (state, action) => ({
            ...state,
            isBusy: false,
            error: action.payload.error
        })
    ],
    [
        (state, action) => (action.type === types.QUERY_TOWNS_SUCCESS),
        (state, action) => ({
            ...state,
            isBusy: false,
            towns: action.payload,
            error: null
        })
    ],
    [
        (state, action) => (action.type === types.QUERY_TRASH_COLLECTION_SITES_FAIL),
        (state, action) => ({
            ...state,
            isBusy: false,
            error: action.payload.error
        })
    ],
    [
        (state, action) => (action.type === types.QUERY_TRASH_COLLECTION_SITES_SUCCESS),
        (state, action) => ({
            ...state,
            isBusy: false,
            trashCollectionSites: action.payload,
            error: null
        })
    ],
    [
        (state, action) => (action.type === types.QUERY_SUPPLY_DISTRIBUTION_SITES_FAIL),
        (state, action) => ({
            ...state,
            isBusy: false,
            error: action.payload.error
        })
    ],
    [
        (state, action) => (action.type === types.QUERY_SUPPLY_DISTRIBUTION_SITES_SUCCESS),
        (state, action) => ({
            ...state,
            isBusy: false,
            supplyDistributionSites: action.payload,
            error: null
        })
    ],
    [
        (state, action) => (action.type === types.BACKUP_RESTORE_FAIL),
        (state, action) => ({
            ...state,
            isBusy: false,
            error: action.payload.error
        })
    ],
    [
        (state, action) => (action.type === types.BACKUP_RESTORE_SUCCESS),
        (state, action) => ({
            ...state,
            isBusy: false,
            backupRestore:Date.now(),
            error: null
        })
    ],
    [
        (state, action) => (action.type === types.RESET),
        () => initialState.tools
    ],
    [
        R.T,
        state => (state || initialState.tools)
    ]
]);
